(function () {
  'use strict';
  angular.module('vcdms.vcdoctype')
    .component('doctypenew', {
      restrict: 'E',
      bindings: {
      },
      template: `
      <div class="doctypenew-component" data-hook="doctypenew-component">
        <h3>Neue/s doctype anlegen</h3>
        <div class="btn btn-success" ng-click="vm.addDoctype()" ng-hide="vm.newdoctype">Neue/s doctype anlegen</div>
        <div ng-show="vm.newdoctype">
          <doctypeform doctype="vm.newdoctype" parentsave="vm.saveNewDoctype(doctype)" oncancel="vm.cancel()"></doctypeform>
        </div>
        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> doctype erfolgreich angelegt!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info"></i> Das Anlegen eines/r neuen doctype wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> doctype konnte nicht angelegt werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Doctype', 'Rlog',
        function ($log, Doctype, Rlog) {
          let vm = this;
          vm.addDoctype = addDoctype;
          vm.saveNewDoctype = saveNewDoctype;
          vm.cancel = cancel;
          
          function addDoctype() {
            vm.newdoctype = {};
            delete vm.created;
            delete vm.canceled;
          }
          
          function saveNewDoctype(doctype) {
            $log.debug('debug: create new doctype: ', doctype);
            delete vm.newdoctype;
            Doctype.$create(doctype).$then(function () {
              vm.created = true;
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new doctype failed: ', err);
              Rlog.error('vcutils.doctype', 'doctypenew', 'Creation of new doctype failed: ', {doctype: vm.newdoctype});
            });
          }
          
          function cancel() {
            delete vm.newdoctype;
            vm.canceled = true;
          }
        }] // controller
    }); // component

// klammerfriedhof
}());
